export function resolveProductFirstImage(productGroup, variant) {
  if (!productGroup || !variant) {
    return null;
  }

  // Loop through shopifyProducts to find the one that matches the variant
  try {
    for (const product of productGroup.shopifyProducts || []) {
      for (const _variant of product.productReferenceV2.variants) {
        if (_variant.id === variant.id) {
          return product.media.edges[0].node.image.originalSrc;
        }
      }
    }
    
    // Fallback: return first image from first product
    return productGroup.shopifyProducts[0]?.media?.edges?.[0]?.node?.image?.originalSrc || null;
  } catch (error) {
    console.log('error', error);
    return [];
  }
}
